export default __webpack_public_path__ + "static/media/Comp 2_00013.b74f3748.png";